module.exports = __webpack_public_path__ + "img/ben-trust-hero.4fd3e9c9.svg";